import BaseGenericRequest from "../BaseGenericRequest";
import TaskResponse from "../TaskResponse";
import {METHOD} from "@cuatroochenta/co-generic-request";
import Urls from "../Urls";
import Exploitation from "../../model/Exploitation";
import {generateRoute} from "../../utils/Router";

export default class TaskExploitationDetail extends BaseGenericRequest<{}, TaskResponse<Exploitation>> {

    public constructor(exploitationId: string) {
        super(METHOD.GET, generateRoute(Urls.URL_EXPLOITATION_DETAIL, {uuid: exploitationId}));
    }
}
